export default __webpack_public_path__ + "static/media/arrowLeft.11c674a5.svg";